module.exports = __webpack_public_path__ + "img/2.58c60993.gif";